import { Image, Path } from './styled';

export const PaginationArrow = ({ forward, disabled, extra }) => (
  <Image
    forward={forward}
    extra={extra}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      disabled={disabled}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.31201 5.3035C0.11223 5.48824 0 5.73877 0 6C0 6.26123 0.11223 6.51176 0.31201 6.6965L5.20657 11.2213C5.40509 11.4011 5.67237 11.5013 5.95033 11.5C6.22828 11.4987 6.49445 11.396 6.691 11.2143C6.88754 11.0326 6.99858 10.7866 6.99999 10.5296C7.00139 10.2727 6.89305 10.0256 6.69849 9.84207L2.54243 6L6.69849 2.15793C6.89305 1.97441 7.00139 1.72732 6.99999 1.47037C6.99858 1.21341 6.88754 0.967353 6.691 0.785657C6.49445 0.60396 6.22828 0.50131 5.95033 0.500012C5.67237 0.498715 5.40509 0.598874 5.20657 0.778726L0.31201 5.3035Z"
    />
  </Image>
);
